export const createInventoryStyles = (theme) => ({
  container: {
    maxWidth: "1800px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  mainLayout: {
    display: "grid",
    gridTemplateColumns: "350px 1fr",
    gap: "24px",
    maxWidth: "1600px",
    margin: "0 auto",
  },
  bankContainer: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    height: "fit-content",
    position: "sticky",
    top: "20px",
  },
  inventorySection: {
    minWidth: 0,
  },
  header: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0 0 8px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  subtitle: {
    fontSize: "16px",
    color: theme.textSecondary,
    margin: 0,
  },
  errorMessage: {
    backgroundColor: (theme.error || "#EF4444") + "20",
    border: `1px solid ${theme.error || "#EF4444"}`,
    color: theme.error || "#EF4444",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  loadingMessage: {
    backgroundColor: (theme.primary || "#6366F1") + "20",
    border: `1px solid ${theme.primary || "#6366F1"}`,
    color: theme.primary || "#6366F1",
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "16px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  controls: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
  },
  addButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
  searchContainer: {
    position: "relative",
    flex: "1",
    minWidth: "250px",
  },
  searchInput: {
    width: "100%",
    paddingLeft: "40px",
    paddingRight: "16px",
    paddingTop: "12px",
    paddingBottom: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.textSecondary,
  },
  formCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  formTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "20px",
    margin: "0 0 20px 0",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "16px",
  },
  formField: {
    display: "flex",
    flexDirection: "column",
  },
  formFieldFull: {
    gridColumn: "1 / -1",
  },
  checkboxField: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    gridColumn: "1 / -1",
    marginTop: "8px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
  },
  checkboxLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme.text,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    accentColor: theme.primary,
    cursor: "pointer",
  },
  select: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    fontFamily: "inherit",
  },
  textarea: {
    padding: "12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "16px",
    height: "80px",
    resize: "vertical",
    fontFamily: "inherit",
  },
  formActions: {
    display: "flex",
    gap: "12px",
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    backgroundColor: theme.success || "#10B981",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    flex: "1",
    justifyContent: "center",
    fontFamily: "inherit",
  },
  cancelButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 24px",
    backgroundColor: theme.warning || "#F97316",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  itemsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
  },
  itemCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    padding: "20px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
    position: "relative",
  },
  itemHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
  },
  itemName: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    margin: "0 0 4px 0",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  quantityBadge: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    backgroundColor: theme.background,
    color: theme.text,
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
  },
  attunementBadge: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    border: `2px solid ${theme.warning}`,
    color: "white",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  itemActions: {
    display: "flex",
    gap: "8px",
  },
  actionButton: {
    padding: "8px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
  editButton: {
    backgroundColor: theme.accent || "#3B82F6",
    color: "white",
  },
  deleteButton: {
    backgroundColor: theme.error || "#EF4444",
    color: "white",
  },
  itemDescription: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "12px",
    lineHeight: "1.4",
  },
  itemMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
    color: theme.text,
    gap: "8px",
    flexWrap: "wrap",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  emptyIcon: {
    marginBottom: "16px",
    opacity: 0.5,
  },
  emptyText: {
    fontSize: "18px",
    color: theme.textSecondary,
    margin: 0,
  },
  categoryHeader: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "16px",
    padding: "12px 16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  categoryStats: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "normal",
  },
  statsCard: {
    backgroundColor: theme.surface,
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    marginBottom: "16px",
  },
  statsRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
    color: theme.text,
    marginBottom: "8px",
  },
  statsRowLast: {
    marginBottom: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "inherit",
  },
});

// Helper function for backward compatibility
export const getInventoryStyles = (theme) => createInventoryStyles(theme);
